module.exports = "/images/inbursa.svg?3fde06a0c0ea2bf9d66565af0297a533";